import { useNavigate } from 'react-router';
import TeaCup from '@/assets/images/svg/tea-cup.svg';
import { StateMessage } from '@/components/shared/state-message';

export const EmptyCoursesList = ({
  isCompleted,
}: {
  isCompleted?: boolean;
}) => {
  const navigate = useNavigate();
  const title = `Você não tem nenhum curso ${isCompleted ? 'concluído' : 'em andamento'}`;
  const subtitle = isCompleted
    ? 'Assista um curso até concluir todo conteúdo.'
    : 'Explore cursos Eduplay e comece a se desenvolver agora mesmo.';

  return (
    <StateMessage
      title={title}
      description={subtitle}
      image={TeaCup}
      action={{
        onClick: () => navigate('/'),
        label: 'Ver cursos',
      }}
    />
  );
};
